import { render, staticRenderFns } from "./LoyaltyProgramDetails.vue?vue&type=template&id=612e0b92&scoped=true"
import script from "./LoyaltyProgramDetails.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramDetails.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyProgramDetails.vue?vue&type=style&index=0&id=612e0b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e0b92",
  null
  
)

export default component.exports